export enum OrganizationTypes {
  CommunityGroup = 'COMMUNITYGROUP',
  Jurisdiction = 'JURISDICTION',
  PatientGroup = 'GROUP',
  Facility = 'FACILITY',
  Clinic = 'CLINIC',
  OpenPod = 'openPod',
}
